import Api from 'requestapijs';
import { HEADER, API_URL } from '../config';
import { addCallHistoryMutation, addCallResponseMutationInput } from '../components/Call/constant';
import { CallHistoryMutationInput, CallResponseMutationInput, CallHistoryMutationPayload } from '../../schema';
import { Inject } from '../helpers';
import { UserService } from './userService';

export class CallHIstoryService {
  static instance: CallHIstoryService;
  @Inject userService: UserService;

  constructor() {
    if (CallHIstoryService.instance) {
      return CallHIstoryService.instance;
    } else {
      CallHIstoryService.instance = this;
    }
  }

  add(
    data: CallHistoryMutationInput,
    onSuccess: (reponse: CallHistoryMutationPayload) => void,
    onError: (response) => void,
  ) {
    Api.graphql<{ input: CallHistoryMutationInput }, { data: {createCallHistory: CallHistoryMutationPayload }}>(
      API_URL,
      { input: { ...data, addedBy: this.userService.user$.getValue().id } },
      addCallHistoryMutation,
      HEADER,
      (response) => {
        onSuccess(response.data.createCallHistory);
      },
      (error) => {
        onError(error);
      },
    );
  }

  addCallResponse(data: CallResponseMutationInput, onSuccess: (response) => void, onError: (response) => void) {
    Api.graphql<{ input: CallResponseMutationInput }, any>(
      API_URL,
      { input: { ...data, addedBy: this.userService.user$.getValue().id } },
      addCallResponseMutationInput,
      HEADER,
      (response) => {
        onSuccess(response);
      },
      (error) => {
        onError(error);
      },
    );
  }
}
